import styled from 'styled-components';

export const BannerStyled = styled.div`
  height: 32rem;
  border: 1px solid red;
  background-image: url("images/banner.jpg");
  background-size: cover;
  background-position: center;
  filter: contrast(75%);
`